/*
  Sometimes, we want elements to have *outer* rounded corners:
             ___________
  __________/           \___________
                        ^ The corner outside the box!

  This component provides that outer rounded corner.
*/

import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  orientation:
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right';
}

function OuterCorner({ orientation, ...delegated }: Props) {
  let rotation;
  if (orientation === 'bottom-right') {
    rotation = 0;
  } else if (orientation === 'bottom-left') {
    rotation = 90;
  } else if (orientation === 'top-left') {
    rotation = 180;
  } else if (orientation === 'top-right') {
    rotation = 270;
  } else {
    throw new Error('Unrecognized orientation: ' + orientation);
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      preserveAspectRatio="none"
      {...delegated}
    >
      <path
        fill="currentColor"
        d="M0 16c8.837 0 16-7.163 16-16v16z"
        style={{
          transform: `rotate(${rotation}deg)`,
          transformOrigin: 'center center',
        }}
      />
    </svg>
  );
}

export default OuterCorner;
